export default defineNuxtPlugin(() => {
  useHead({
    script: [
      {
        src: '//cdn.cookie-script.com/s/c96ed13c6bf7a3fa9805f8a81d442b1c.js',
        async: true,
        type: 'text/javascript',
        tagPosition: 'bodyClose' 
      }
    ]
  })
})